import { getFetchedDataPayload } from '@vista-digital/utilities';
import { loyaltyDomainStore } from '../../../store';
export const memberHasWatchlistFilm = (filmId) => {
    const watchlistFilms = getFetchedDataPayload(loyaltyDomainStore.data.memberWatchlistFilmsById);
    return watchlistFilms && !!watchlistFilms[filmId];
};
//# sourceMappingURL=member-has-watchlist-film.js.map